import React, { useEffect, useState } from "react";
import { useCompatRouter as useRouter } from "@/lib/compat-router/context";
import FormInput from "../input";
import DropdownMenu from "../dropdown";
import Button from "../button";
import { getCitiesByState, nigeriaStates } from "@/utils/location";
import { Search } from "@/components/bnp-icons";
import { Controller } from "react-hook-form";
import {
  getDevelopmentType,
  developmentTypeMapping,
} from "@/components/pages/user/dashboard/properties/Tabs/investment-tabs/StepOne";

const InvestmentFilters = () => {
  const router = useRouter();
  const [cityOptions, setCityOptions] = useState<string[]>([]);

  const { state, city, developmentType } = router.query;
  const [selectedState, setSelectedState] = useState<any>(state || null);

  const [filters, setFilters] = React.useState({
    state: state || "",
    city: city || "",
    bedroomCount: "",
    bathroomCount: "",
    developmentType: developmentType || "",
    minInvestment: "",
    maxPrice: "",
  });

  useEffect(() => {
    if (selectedState) {
      const cities = getCitiesByState(selectedState);
      setCityOptions(cities);
    } else {
      setCityOptions([]);
    }
  }, [selectedState]);

  const handleFilterChange = (key: string, value: string) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const applyFilters = () => {
    const queryParams = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== "Any") {
        queryParams.append(key, value.toString());
      }
    });

    router.push({
      pathname: router.pathname,
      query: queryParams.toString(),
    });
  };

  const clearFilters = () => {
    setFilters({
      state: "Any",
      city: "Any",
      bedroomCount: "Any",
      bathroomCount: "Any",
      developmentType: "Any",
      minInvestment: "Any",
      maxPrice: "Any",
    });
    router.push(router.pathname);
  };

  return (
    <div className="w-full">
      <div className="pt-6">
        <div className="w-full bg-white border rounded-lg p-4 shadow-md">
          <h2 className="text-lg my-4 font-medium text-main-900">
            Search Filters
          </h2>
          <div className="min-w-[260px] flex flex-col gap-1 mb-4">
            <p className="text-sm font-semibold text-main-900">Offering Type</p>
            <DropdownMenu
              name="developmentType"
              value={
                getDevelopmentType(
                  developmentTypeMapping,
                  filters?.developmentType,
                ) || "Any"
              }
              onChange={(e) => {
                const apiValue =
                  e.target.value === "Any"
                    ? ""
                    : developmentTypeMapping[
                        e.target.value as keyof typeof developmentTypeMapping
                      ];
                handleFilterChange("developmentType", apiValue);
              }}
              options={Object.keys(developmentTypeMapping)}
            />
          </div>

          {/* <div className="min-w-[260px] flex flex-col gap-1">
            <p className="text-sm font-semibold text-main-900">
              Minimum investment (₦)
            </p>
            <DropdownMenu
              name="minInvestment"
              options={[
                "Any",
                "100,000",
                "200,000",
                "500,000",
                "1,000,000",
                "2,000,000+",
              ]}
              onChange={(e) =>
                handleFilterChange("minInvestment", e.target.value === "Any" ? "" : e.target.value)
              }
              value={filters?.minInvestment || "Any"}
            />
          </div> */}
          <div className="flex justify-center items-center gap-4 ">
            <Button
              onClick={clearFilters}
              className="mt-4 lg:mt-6 bg-white font-sans text-bnp-dark border-[1.4px] border-bnp-dark text-sm font-semibold w-[300px] lg:w-[137px] h-[52px] rounded-lg"
            >
              <div className="flex gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-filter-x"
                >
                  <path d="M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055" />
                  <path d="m22 3-5 5" />
                  <path d="m17 3 5 5" />
                </svg>
                <p>Clear</p>
              </div>
            </Button>
            <Button
              onClick={applyFilters}
              className="mt-4 lg:mt-6 bg-bnp-dark font-sans text-white text-sm font-semibold w-[300px] lg:w-[137px] h-[52px] rounded-lg"
            >
              <div className="flex gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-filter"
                >
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                </svg>
                <p>Apply</p>
              </div>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestmentFilters;
